export default __webpack_public_path__ + "static/media/19683.b2d699de.png";